module.exports = __webpack_public_path__ + "img/cpjs_bg.0a419fdc.jpg";